'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgProfileCircle(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...props },
        React__default.default.createElement("defs", null,
            React__default.default.createElement("path", { d: "M5.996 12C9.273 12 12 9.279 12 6S9.266 0 5.989 0C2.719 0 0 2.721 0 6s2.727 6 5.996 6zm0-9.338c1.122 0 2.006.974 2.006 2.156 0 1.256-.884 2.215-2.006 2.2-1.122-.014-1.998-.944-1.998-2.2-.008-1.182.884-2.156 1.998-2.156zM9.49 9.45l.022.074c-.907.952-2.244 1.465-3.515 1.465-1.27 0-2.6-.513-3.507-1.465l.022-.074C2.965 8.796 4.146 8 5.996 8c1.858 0 3.04.796 3.493 1.45z", id: "Profile-circle_svg__a" })),
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("g", { transform: "translate(2 2)" },
                React__default.default.createElement("path", { d: "M0 0h12v12H0z" }),
                React__default.default.createElement("use", { fill: "currentColor", xlinkHref: "#Profile-circle_svg__a" })))));
}

module.exports = SvgProfileCircle;
//# sourceMappingURL=ProfileCircle.js.map
